
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient, { IMAGE_BASE_URL } from '../../utils/api-client';
import CardSkeleton from '../Common/CardSkeleton';
import './BlogItem.css';

const BlogItem = ({ currentPage , setCurrentPage , totalPages , setTotalPages }) => {

  const [blogs, setBlogs] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    apiClient
      .get('/blog' , {
        params: {
          page: currentPage
        }
      })
      .then((res) => {
        if (res.data.status == true) {
          const {data , current_page , last_page} = res.data.data
          setBlogs(data);
          setCurrentPage(current_page);
          setTotalPages(last_page);
          setIsLoading(false);
        }else{
          setBlogs([]);
          setIsLoading(false);
        }
      
      })
      .catch((err) => {
        setError(err.message);
        setIsLoading(false);
      });
  }, [currentPage]);

  return (
    <>
      {error && <em className="form_error">{error}</em>}
      {isLoading && <CardSkeleton cards={8} />}
      {blogs &&
        blogs.map((blog) => (
          <div key={blog.id}>
            <div className="blog-card shadow-sm rounded-3 overflow-hidden">
              <Link to={`/blog-detail/${blog.b_slug}/`}>
                <img
                  src={`${IMAGE_BASE_URL}/${blog.b_image}`}
                  className="blog-image"
                  alt={blog.b_title}
                />
              </Link>
              <div className="blog-body p-3">
                <div className="blog-date mb-2 text-muted small d-flex align-items-center">
                  <i className="fa-regular fa-calendar-check me-2 date-icon" />
                  {blog.b_datetime}
                </div>

                <Link
                  to={`/blog-detail/${blog.b_slug}/`}
                  className="text-decoration-none"
                >
                  <h5 className="blog-title mb-2">{blog.b_title}</h5>
                </Link>

                <Link
                  to={`/blog-detail/${blog.b_slug}`}
                  className="read-more-btn mt-2"
                >
                  Read More
                </Link>
              </div>
            </div>
          </div>
        ))}

    
    </>
  );
};

export default BlogItem;
